import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const addItemSavingsBasketSelector = createSelector(testTargetOffersSelector, offers => offers.addItemSavingsBasket || Empty.Object);

export { addItemSavingsBasketSelector };
